import * as constants from 'consts';

export const expandNav = () => {
  return {
    type: 'NAV_EXPAND',
  };
};

export const collapseNav = () => {
  return {
    type: 'NAV_COLLAPSE',
  };
};

export const expandSidebar = () => {
  return {
    type: 'SIDEBAR_EXPAND',
  };
};

export const collapseSidebar = () => {
  return {
    type: 'SIDEBAR_COLLAPSE',
  };
};

export const addLoader = (payload) => {
  return {
    type: 'LOADER_ADD',
    payload,
  };
};

export const removeLoader = (payload) => {
  return {
    type: 'LOADER_REMOVE',
    payload,
  };
};

export const showModal = (payload) => {
  return {
    type: 'MODAL_SHOW',
    payload,
  };
};

export const hideModal = (type) => {
  return {
    type: 'MODAL_HIDE',
    payload: type,
  };
};

export const fullScreenModal = (payload) => {
  return {
    type: 'MODAL_FULLSCREEN',
    payload,
  };
};

export const enqueueNotification =
  (str, type, { data, delay } = {}) =>
  (dispatch, getState) => {
    const defaultNotification = {
      key: new Date().getTime(),
      visible: true,
      type,
      data,
      delay,
      message: str,
    };

    const currentNotification = getState().ui.notification.queue[0];

    // if it's the 1st notification, we add it (visible by default)
    // if not, we add it to the list (hidden) then process the queue
    if (!currentNotification) {
      dispatch(addNotification(defaultNotification));
    } else {
      dispatch(hideNotification(currentNotification.key));
      dispatch(addNotification({ ...defaultNotification }));
    }
  };

export const addNotification = (payload) => {
  return {
    type: 'NOTIFICATION_ADD',
    payload,
  };
};

export const hideNotification = (payload) => {
  return {
    type: 'NOTIFICATION_HIDE',
    payload,
  };
};

export const removeNotification = (payload) => {
  return {
    type: 'NOTIFICATION_REMOVE',
    payload,
  };
};

export const updateApp = (payload) => {
  return {
    type: 'SW_UPDATE',
    payload,
  };
};

export const setBrand = (hostname) => {
  // set brand based on domain name (default to priceforbes)
  let brand = constants.BRAND_PRICEFORBES;
  if (hostname.includes(constants.BRAND_BISHOPSGATE)) brand = constants.BRAND_BISHOPSGATE;

  return {
    type: 'BRAND_SET',
    payload: brand,
  };
};
